export const TICKETS_LOAD = 'TICKETS_LOAD';
export const TICKETS_LOAD_SUCCESS = 'TICKETS_LOAD_SUCCESS';
export const TICKETS_LOAD_ERROR = 'TICKETS_LOAD_ERROR';
export const TICKETS_ADD = 'TICKETS_ADD';
export const TICKETS_ADD_SUCCESS = 'TICKETS_ADD_SUCCESS';
export const TICKETS_ADD_ERROR = 'TICKETS_ADD_ERROR';
export const TICKETS_UPDATE = 'TICKETS_UPDATE';
export const TICKETS_UPDATE_SUCCESS = 'TICKETS_UPDATE_SUCCESS';
export const TICKETS_UPDATE_ERROR = 'TICKETS_UPDATE_ERROR';
export const TICKETS_DELETE = 'TICKETS_DELETE';
export const TICKETS_DELETE_SUCCESS = 'TICKETS_DELETE_SUCCESS';
export const TICKETS_DELETE_ERROR = 'TICKETS_DELETE_ERROR';
